document.write(unescape("%3Cscript src='https://cdn.jsdelivr.net/npm/sweetalert2@9' type='text/javascript'%3E%3C/script%3E"));
var style = document.createElement('style');
style.innerHTML = `
 /* The Modal (background) */
.popedit-modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content/Box */
.popedit-modal-content {
  background-color: #FFF;
        padding: 28px 32px;
        border: 1px solid #99a9b5;
        width: 100%;
        height: auto;
        max-height: calc(100vh - 4rem);
        max-width: 700px;
        border-radius: 4px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        overflow-y: auto;
}

/* The Close Button */
.popedit-close {
  position: absolute;
  right: 32px;
  top: 28px;
}

.popedit-close:hover,
.popedit-close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
`;
document.head.appendChild(style);

window.Notify = new function () {
    var self = this;
    self.alert = function (title, callback) {
        Swal.fire({
            title: title,
            onClose: function () {
                if ((typeof callback !== 'undefined')) {
                    callback()
                }
            }
        });
    }

    self.success = function (title, message, callback) {
        message = (typeof message !== 'undefined') ? message : "";
        Swal.fire({
            title: title,
            text: message,
            icon: "success"
        }).then(function (result) {
            callback(result.isConfirmed);
        })
    }

    self.error = function (title, message, callback) {
        message = (typeof message !== 'undefined') ? message : "";
        Swal.fire({
            title: title,
            text: message,
            icon: "error",
            buttonsStyling: false,
            customClass: {
                confirmButton: 'btn btn-red',
                title: 'title-popup'
            },
            onClose: function () {
                if ((typeof callback !== 'undefined')) {
                    callback()
                }
            }
        });
    }

    self.error_cd = function (title, message) {
        message = (typeof message !== 'undefined') ? message : "";
        var timerInterval;
        Swal.fire({
            //title: 'Auto close alert!',
            html: message,
            title: title,
            icon: "error",
            timer: 5000,
            backdrop: false,
            timerProgressBar: true,
            onBeforeOpen: function () {
                Swal.showLoading()
                timerInterval = setInterval(function () {
                    Swal.getContent().querySelector('b')
                        .textContent = (Swal.getTimerLeft() / 1000).toFixed(0)
                }, 100)
            },
            onClose: function () {
                clearInterval(timerInterval)
            }
        }).then(function (result) {
            if (
                result.dismiss === Swal.DismissReason.timer
            ) {
                console.log('I was closed by the timer')
            }
        })
    }

    self.confirm = function (title, message, callback) {
        message = (typeof message !== 'undefined') ? message : "";
        Swal.fire({
            title: title,
            text: message,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#D21359",
            confirmButtonText: "Ok",
            cancelButtonText: "Annulla"
        }).then(function (result) {
            callback(result.isConfirmed);
        })
    }

    self.confirm_html = function (title, message, callback) {
        message = (typeof message !== 'undefined') ? message : "";
        Swal.fire({
            title: title,
            html: message,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#D21359",
            confirmButtonText: "Ok",
            cancelButtonText: "Annulla"
        }).then(function (result) {
            callback(result.isConfirmed);
        })
    }

    self.confirm_simple = function (title, message, callback) {
        message = (typeof message !== 'undefined') ? message : "";
        Swal.fire({
            title: title,
            html: message,
            icon: false,
            showCancelButton: true,
            confirmButtonColor: "#D21359",
            cancelButtonColor: "#D8D8D8",
            confirmButtonText: "CONFERMA",
            cancelButtonText: "Indietro",
            buttonsStyling: false,
            reverseButtons: true,
            focusConfirm: false,
            focusCancel: false,
            customClass: {
                container: 'popup-configuratore',
                popup: 'popup-configuratore__popup',
                title: 'popup-configuratore__title',
                htmlContainer: 'small',
                actions: 'actions',
                confirmButton: 'ml-2 btn btn-full-primary',
                cancelButton: 'mr-2 btn btn-transparent-primary',
                timerProgressBar: 'progress',
            }
        }).then(function (result) {
            callback(result.isConfirmed);
        })
    }

    self.html = function (html) {
        Swal.fire({
            html: html,
            showConfirmButton: false,
            showCloseButton: true
        });
    }

    self.toast = function (message, icon) {
        message = (typeof message !== 'undefined') ? message : "";
        icon = (typeof icon !== 'undefined') ? icon : "";
        Swal.fire({
            icon: icon,
            title: message,
            toast: true,
            position: 'top-end',
            timer: 3000,
            timerProgressBar: true,
            onOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            },
            showConfirmButton: false,
        });
    }

    self.toastSuccess = function (message) {
        message = (typeof message !== 'undefined') ? message : "";
        Swal.fire({
            icon: 'success',
            title: message,
            toast: true,
            position: 'top-end',
            timer: 3000,
            timerProgressBar: true,
            onOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            },
            showConfirmButton: false,
        });
    }

    self.toastError = function (message) {
        message = (typeof message !== 'undefined') ? message : "";
        Swal.fire({
            icon: 'error',
            title: message,
            toast: true,
            position: 'top-end',
            timer: 3000,
            timerProgressBar: true,
            onOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            },
            showConfirmButton: false,
        });
    }

    self.popupModal = function (html, classe) {
        // Get the modal

        /*var span = document.getElementsByClassName("close")[0];
        btn.onclick = function () {
            modaledit.style.display = "block";
        }
        span.onclick = function () {
            modaledit.style.display = "none";
        }*/

        if(typeof(classe) == "undefined" || classe == null) {
            classe = "";
        }

        var template = `
            <div id="popupedit" class="popedit-modal">
                <div class="popedit-modal-content ` + classe + `">
                    <span class="popedit-close">
                        <svg class="block" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g>
                            <path d="M12.6666 4.7735L11.7266 3.8335L7.99992 7.56016L4.27325 3.8335L3.33325 4.7735L7.05992 8.50016L3.33325 12.2268L4.27325 13.1668L7.99992 9.44016L11.7266 13.1668L12.6666 12.2268L8.93992 8.50016L12.6666 4.7735Z" fill="#002846"/>
                            </g>
                        </svg>
                    </span>
                    ` + html + `
                </div>
            </div>
        `;
        $("body").append(template);
        $("#popupedit").fadeIn();
        var modaledit = document.getElementById("popupedit");
        var span = document.getElementsByClassName("popedit-close")[0];
        span.onclick = function () {
            $("#popupedit").fadeOut(function () {
                $(this).remove();
            });
        }
        window.onclick = function (event) {
            if (event.target == modaledit) {
                $("#popupedit").fadeOut(function () {
                    $(this).remove();
                });
            }
        }
    }

    self.removePopup = function () {
        $("#popupedit").fadeOut(function () {
            $(this).remove();
        });
    }
}
